export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px'
  },
  footer: { margin: '10px' },
  row: { display: 'flex', alignItems: 'center', marginLeft: '20px' },
  info: { fontSize: '14px', margin: '10px 0' },
  smallInfo: { fontSize: '10px' },
  errors: {
    padding: '10px 0'
  },
  summary: {
    padding: '10px 0'
  },
  summaryRow: {
    marginBottom: '8px'
  },
  summaryErrors: {
    fontSize: '12px',
    marginLeft: '10px'
  },
  loaderOverlay: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    background: '#FFF',
    opacity: '.5',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
};
